import * as angular from 'angular';

import { Group } from '../../models';
import { IGroupService } from '../data';
import { IWorkspaceService } from '../general';

export interface IGroupSelectionService {
    selectedGroup(group?: Group): Group;
    reselectGroup(groupGuid: string): angular.IPromise<Group>;
}

export class GroupSelectionService implements IGroupSelectionService {
    static serviceId = 'groupSelectionService';

    private _selectedGroup: Group[] = [];

    static $inject = ['groupService', 'workspaceService'];

    constructor(
        private _groupService: IGroupService,
        private _workspaceService: IWorkspaceService
    ) {
    }

    selectedGroup(group?: Group): Group {
        const app = this._workspaceService.getWorkspace().application;
        if (arguments.length) {
            this._selectedGroup[app] = group;

        }

        return (this._selectedGroup && this._selectedGroup.hasOwnProperty(app))
            ? this._selectedGroup[app]
            : undefined;
    }

    reselectGroup(groupGuid: string): angular.IPromise<Group> {
        return this._groupService.getByGuid(groupGuid).then(groupDto => {
            return this.selectedGroup(groupDto.group);
        });
    }
}